





































































































import { Component, Prop, Vue } from "vue-property-decorator";
import firebase from "firebase/app";

import { LoginState } from "@/store/modules/user";

@Component({
    components: {},
})
export default class ChangePassword extends Vue {
    private user = this.$store.getters.user;
    private email = this.$store.getters.user.email;

    async mounted() {
        // const loginState = await this.$store.dispatch("loginState");
        // console.log("loginState", loginState);
        // switch (loginState) {
        //     case LoginState.no_user:
        //         await this.$router.replace("/");
        //         break;
        //     case LoginState.logout:
        //         await this.$router.replace("/");
        //         break;
        // }
    }
}
